import { render } from "./AdminActionDraftBlock.vue?vue&type=template&id=62d60f7f&scoped=true"
import script from "./AdminActionDraftBlock.vue?vue&type=script&lang=js"
export * from "./AdminActionDraftBlock.vue?vue&type=script&lang=js"

import "./AdminActionDraftBlock.vue?vue&type=style&index=0&id=62d60f7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d60f7f"]])

export default __exports__